<template>

  <div><!-- this div remove the routerView CSS herit (need fullscreen) -->
    <Transition name="fade" v-if="userOAuthChecked">
      <div class="playWeetLayout" ref="playerFullScreen" :class="classLayout" v-show="mustShow">

        <!-- PLAYER -->
        <div class="mainLineLayout">
          <!-- TOP BAR OF PLAYER -->
          <div class="topBar">
            <div class="titleContainer" v-if="weet">
              <!-- TITLE LINE -->
              <w-error class="errorMessage" :message="errormsg"/>
              <div class="lineContainer">
                <div class="topBarLeft">
                  <!-- TITLE LINE -->
                  <div class="titleEditable" steptour="titleLine" :contenteditable="isEditable"
                       v-text="weetTitle" :class="isEditable?'editable':'none'"
                       @focusout="validateTitle" @keydown.enter="focusOutTitleEdition"/>
                </div>
                <div class="topBarRight" v-if="weet">
                  <div class="channelWeetContainer">
                    <ChannelWeetView :weet="weet"/>
                  </div>
                  <WeetAudienceButton :weet="weet"/>
                </div>
              </div>
            </div>
            <div v-else class="emptyTitleContainer">

            </div>
          </div>
          <!-- LEFT COLUMN -->
          <div class="columnleft" :class="(!isCommentEnabled && totalComment===0)?'central':''">

            <div ref="videoContainer" class="weetContainer">
              <WeetPlayer :key=" 'WeetPlayer' + weetID" v-if="!isUpdateMode"
                          steptour="playerVideo"
                          :weetID="weetID"
                          :timeStart="time" :autoplay="autoplay"
                          fullScreenElement="playerFullScreen"
                          @controlChange="onControlChange"/>
            </div>

            <div class="weetInformation">
              <div class="ownersLine">
                <div class="leftColumn">
                  <div class="ownerElement">
                    {{ $t('playView.ownerBy', { name: nameOfOwner }) }}
                    <div class="dotSeperator">{{ $t('generic.dot2') }}</div>
                    <w-tool-tip size="small" position="top" :label="toolTipDateCreation">
                      {{ dateOfCreation }}
                    </w-tool-tip>
                  </div>
                </div>
                <div class="rightColumn">
                  <w-tool-tip :label="$t('archive.informations')" :position="'top-start'" v-if="isShowArchiveMessage">
                    <div class="archiveElement">
                      <w-icon icon="information-outline" size="small" class="iconItem"/>{{$t('archive.archive') }}
                    </div>
                  </w-tool-tip>

                  <CopyThumbnailWeetButton class="buttonAction" :weet="weet" color="outlined" size="small"/>
                  <CopyWeetButton class="buttonAction" :weet="weet" color="outlined" size="small"/>
                  <ShareLinkButton class="buttonAction" size="small" :weet="weet" v-if="weet"/>
                  <w-button size="small" color="outlined" data-test="editWeet" class="buttonAction"
                            icon="pencil-outline" :stepTour="'addSection'"
                            v-if="isEditable " @click="editAWeet" :enabled="!weet.hidden"/>
                  <MenuWeet class="buttonAction" :weet="weet" v-if="weet && isAuthenticated"/>
                </div>
              </div>

            </div>

            <!-- STAT LINE -->
            <div class="statLine">

              <div class="statElement" v-if="weet">
                <!-- View -->
                <w-tool-tip :label="weet.views+' '+$tc('generic.view',weet.views)" size="small" position="top">
                  <w-icon icon="eye-outline" class="iconView" color="light2"/>
                </w-tool-tip>
                <div class="numberView"> {{ weet.views }}</div>

                <!-- Viewer -->
                <WeetViewersTooltip :weet="weet"/>
              </div>

            </div>


          </div>
          <Transition name="slideRight">
            <!-- RIGHT COLUMN -->
            <div class="columnRight" v-show="mustShowInteraction">
              <div class="spacerFullScreen" v-show="isFullscreen"></div>
              <div class="closeButton" v-show="isFullscreen">
                <w-button icon="close" size="small" color="text" @click="askPanelInFullScreen=false"/>
              </div>
              <b-tabs class="rightColumnTabs" position="is-left" v-model="tabSelected">
                <b-tab-item>
                  <template #header>
                  <span>{{ $t('commentPanelView.tab.interaction') }} <b class="roundChannel">{{
                      totalComment
                    }} </b>  </span>
                  </template>
                  <div class="commentCreatorRightPanel">
                    <CommentPanelCreator class="panelCreator" steptour="commentAWeet" :weet="weet"
                                         v-if="isCommentEnabled "/>
                    <div class="notificationHelper">
                      <NotificationWeetHelper :weet-i-d="weetID"/>
                    </div>

                  </div>

                  <!-- LIST COMMENT -->
                  <div>
                    <CommentPanelView class="commentPanelView" v-if="weet!==undefined && tabSelected===0"
                                      v-show="mustShow"
                                      :weet="weet"/>
                  </div>
                </b-tab-item>

                <!-- TRANSCRIPT-->
                <b-tab-item>
                  <template #header>
                    <span>{{ $t('commentPanelView.tab.transcript') }}</span>
                  </template>
                  <div>
                    <SubtitleTextPanel :weet="weet" v-if="tabSelected===1"/>
                  </div>
                </b-tab-item>
                <!-- CHAPTERS -->
                <b-tab-item>
                  <template #header>
                    <span>{{ $t('commentPanelView.tab.chapters') }}</span>
                  </template>
                  <div>
                    <ChapterPanel :weet="weet" v-if="tabSelected===2"/>
                  </div>
                </b-tab-item>
              </b-tabs>
            </div>
          </Transition>
        </div>

        <Transition name="fade"
                    leave-active-class="none">
          <div class="openFullscreenPanelButton" v-show="!askPanelInFullScreen && canOpenRightPanel"
               @click="askPanelInFullScreen=true">
            <w-tool-tip color="light" :label="$t('player.comment.fullscreen.tooltip')" position="left">
              <w-button icon="comment-outline" color="light" size="small"/>
            </w-tool-tip>
          </div>
        </Transition>

        <!-- SESSION MANAGEMENT -->
        <WeetViewManager :weetID="weetID"/>
      </div>
    </Transition>

  </div>

</template>
<script lang="ts">
import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import WeetPlayer from '@/components/play/player/WeetPlayer.vue';
import WButton from '@/components/wrapper/w-button.vue';
import store from '@/store';
import {Weet} from '@/store/weet/weetModel';
import {User} from '@/store/user/userModel';
import {SEND_CHANGE_WEET_TITLE} from '@/store/myWeet/myWeetAction';
import WError from '@/components/wrapper/w-error.vue';
import {capitalize, getDateAgo, getLocalTime, getThumbnailURL, getUserAvatar} from '@/utils/util';
import WeetViewManager from '@/components/play/weetView/WeetViewManager.vue';
import WIcon from '@/components/wrapper/w-icon.vue';
import WToolTip from '@/components/wrapper/w-toolTip.vue';
import {
  canEditOrCommentThisWeet,
  canEditThisWeet, isOwner,
  launchWeetCreation,
  userFirstNameTooltip,
  userLastNameTooltip
} from '@/utils/weetUtil';
import ShareButton from '@/components/actionButton/ShareButton.vue';
import UserAvatar from '@/components/user/UserAvatar.vue';
import CommentLoader from '@/components/play/comment/CommentLoader.vue';
import CommentPanelView from '@/components/comment/CommentPanelView.vue';
import slugify from '@sindresorhus/slugify';
import ShareLinkButton from '@/components/actionButton/ShareLinkButton.vue';
import {setActionEvent, setPageEvent} from '@/utils/tracker';
import {ActionEvent, PageEvent} from '@/enum/TrackerEnum';
import {COMMENT_TO_REPLY, OPEN_PANEL_REPLY} from '@/store/comment/commentAction';
import NotificationWeetHelper from '@/components/notifications/NotificationWeetHelper.vue';
import CommentPanelCreator from '@/components/comment/CommentPanelCreator.vue';
import MenuWeet from '@/components/menu/MenuWeet.vue';
import mobileDetect from 'mobile-device-detect';
import {CommentPolicy} from '@/store/weet/CommentPolicy';
import {VisibilityPolicy} from '@/store/weet/VisibilityPolicy';
import {hideGlobalTour} from '@/utils/tour';
import CopyWeetButton from '@/components/actionButton/CopyWeetButton.vue';
import {inform} from '@/utils/dialog';
import WeetViewersTooltip from '@/components/weet/viewer/WeetViewersTooltip.vue';
import {selectWorkspaceFromWeet} from '@/utils/workspaceUtil';
import {disconnectAndRefresh} from '@/utils/identityUtil';
import {ExternalToolEnum} from '@/enum/ExternalToolEnum';
import {CHECK_CONNECTED_TOKEN_EXTERNAL_USER} from '@/store/identity/identityAction';
import {Token} from '@/store/identity/identityModel';
import ChannelWorkspace from '@/components/channel/ChannelWorkspace.vue';
import ChannelWorkspaceAddDropDown from '@/components/channel/ChannelWorkspaceAddDropDown.vue';
import {Channel} from '@/store/channel/channelModel';
import ButtonUsers from '@/components/actionButton/ButtonUsers.vue';
import WeetAudienceButton from '@/components/channel/WeetAudienceButton.vue';
import ChannelWeetView from '@/components/channel/ChannelWeetView.vue';
import CopyThumbnailWeetButton from '@/components/actionButton/CopyThumbnailWeetButton.vue';
import SubtitleTextPanel from "@/components/recorder/subtitle/SubtitleTextPanel.vue";
import ChapterPanel from "@/components/chapters/ChapterPanel.vue";
import {SELECT_MODE} from "@/store/advancedEditing/advancedEditingAction";
import {AdvancedEditingMode} from "@/enum/AdvancedEditingMode";

@Component<PlayWeet>({
  components: {
    ChapterPanel,
    SubtitleTextPanel,
    CopyThumbnailWeetButton,
    ChannelWeetView,
    WeetAudienceButton,
    ButtonUsers,
    ChannelWorkspaceAddDropDown,
    ChannelWorkspace,
    WeetViewersTooltip,
    CopyWeetButton,
    MenuWeet,
    CommentPanelCreator,
    NotificationWeetHelper,
    ShareLinkButton,
    CommentPanelView,
    CommentLoader,
    UserAvatar,
    ShareButton,
    WToolTip,
    WIcon,
    WeetViewManager,
    WError,
    WButton,
    WeetPlayer,
  },
  metaInfo() {
    return {
      title: this.weetTitleSEO,
      meta: [
        // OpenGraph data (Most widely used)
        {property: 'og:title', content: this.weetTitleSEO},
        {property: 'og:site_name', content: 'WEET'},
        {property: 'robots', content: this.weetIndexSEO},
        // The list of types is available here: http://ogp.me/#types
        {property: 'og:type', content: 'website'},
        // Should the the same as your canonical link, see below.
        {property: 'og:url', content: document.location.href},
        {property: 'og:image', content: this.thumbnailSEO},
        // Often the same as your meta description, but not always.
        {property: 'og:description', content: this.weetTitleSEO},

        // Twitter card
        {name: 'twitter:card', content: 'summary'},
        {name: 'twitter:site', content: document.location.href},
        {name: 'twitter:title', content: this.weetTitleSEO},
        {name: 'twitter:description', content: this.weetTitleSEO},
        // Your twitter handle, if you have one.
        // {name: 'twitter:creator', content: '@alligatorio'}
        {name: 'twitter:image:src', content: this.thumbnailSEO},

        // Google / Schema.org markup:
        {itemprop: 'name', content: this.weetTitleSEO},
        {itemprop: 'description', content: this.weetTitleSEO},
        {itemprop: 'image', content: this.thumbnailSEO},
      ],
    };
  },
})
export default class PlayWeet extends Vue {
  @Prop({default: ''})
  public weetID!: string;
  @Prop({default: ''})
  public title!: string;
  @Prop({default: '0'})
  public time!: string;
  @Prop({default: ''})
  public commentID!: string;
  @Prop({default: ''})
  public commentToReply!: string;


  @Prop({default: ''})
  public tool!: string;

  @Prop({default: ''})
  public accessToken!: string;


  private errormsg: string = '';
  private mustShow: boolean = false;
  private tabSelected: number = 0;
  private askPanelInFullScreen: boolean = false;
  private controlPlayerShow: boolean = true;
  // true if there is no oauth, or if the user oauth has been checked and is the same as the user connected
  private userOAuthChecked: boolean = false;


  private isMobile: boolean = false;


  get weet(): Weet {
    return store.getters.getWeet(this.weetID);
  }

  get getChannels(): Channel[] {
    if (this.weet) {
      return this.weet.channels;
    } else {
      return [];
    }
  }

  get isShowArchiveMessage():boolean{
    if(this.weet){
     return isOwner(this.weet) && this.weet.archive;
    }else{
      return false;
    }
  }

  get totalComment(): number {
    return store.getters.getTotalOfComment;
  }

  get isCommentEnabled(): boolean {
    if (this.weet) {
      return this.weet.commentPolicy !== CommentPolicy.NOBODY_CAN_COMMENT;
    } else {
      return false;
    }
  }
  get autoplay():boolean{
    return store.getters.isAutoPlay;
  }

  // check if token has to be checked
  get tokenDontNeedToBeChecked(): boolean {
    return this.accessToken === '' || this.tool.toUpperCase() !== ExternalToolEnum.OTHER;
  }

  get isUpdateMode(): boolean {
    return store.getters.showPopUpCreation;
  }

  get weetViewers(): User[] {
    if (canEditThisWeet(this.weet)) {
      return store.getters.getWeetViews;
    }
    return [];
  }

  get userConnected(): User {
    return store.getters.userConnected;
  }


  public async mounted() {

    this.userOAuthChecked = this.tokenDontNeedToBeChecked;
    // we have to do it in the mounted because we need to do it before everything, and because we log out if the user is not the right user
    // and we don't want any request to be sent while we are logged out
    if (!this.userOAuthChecked) {
      await this.checkConnectedUserAuthorizationAndDoActions();
    }

    setTimeout(() => {
      this.mustShow = true;
    }, 500);
    // detect if mobile
    this.isMobile = mobileDetect.isMobile;

    // the time is provide by the router, and this is a string, so we have to parse in number
    setPageEvent(PageEvent.page_player, {weetID: this.weetID});

    if (this.commentToReply) {
      store.dispatch(COMMENT_TO_REPLY, this.commentToReply);
      store.dispatch(OPEN_PANEL_REPLY, this.commentID);
    } else if (this.commentID) {
      store.dispatch(COMMENT_TO_REPLY, this.commentID);
      store.dispatch(OPEN_PANEL_REPLY, this.commentID);
    } else {
      store.dispatch(COMMENT_TO_REPLY, '');
      store.dispatch(OPEN_PANEL_REPLY, '');
    }
  }

  public cleanParamsFromUrl() {
    // Replace the history to hide all query parameters coming from slack/teams
    history.replaceState({}, '', this.$route.path);
  }

  /**
   * Check if the connected user has the authorization to view the weet.
   * If user is coming from external tool, check if connected user is the same as the user who performs the oauth with the external tool.
   * Return true or false
   */
  public async checkConnectedUserAuthorizationAndDoActions() {
    return await store.dispatch(CHECK_CONNECTED_TOKEN_EXTERNAL_USER, new Token(this.accessToken))
        .then(() => {
          this.userOAuthChecked = true;
          this.cleanParamsFromUrl();
        }).catch((err) => {
          disconnectAndRefresh();
        })
        ;
  }


  get getListOfOwner(): User[] {
    const listOwner: User[] = [];
    if (this.weet) {
      for (const owner of this.weet.owners) {
        listOwner.push(owner.user);
      }
    }
    return [...listOwner].reverse();
  }


  private getAvatarForUser(user: User): string {
    return getUserAvatar(user, 96);
  }

  private getUserFirstNameTooltip(user: User): string {
    return userFirstNameTooltip(user, this.weet);
  }

  private getUserLastNameTooltip(user: User): string {
    return userLastNameTooltip(user, this.weet);
  }

  get classLayout(): string {
    let classes = '';
    if (this.isFullscreen) {
      classes += 'layoutFullScreen ';
    } else {
      classes += 'nofullscreen ';
    }
    if (this.isMobile) {
      classes += 'layoutMobile ';
    }

    return classes;
  }

  get isFullscreen(): boolean {
    return store.getters.isFullscreenMode;
  }

  get canOpenRightPanel(): boolean {
    return this.isFullscreen && this.controlPlayerShow;
  }

  get isShowCommentPanel(): boolean {
    if (!store.getters.isAuthenticated || !this.weet) {
      return true;
    } else {
      return canEditOrCommentThisWeet(this.weet, store.getters.userConnected);
    }
  }

  get commentIDToReply(): string {
    return store.getters.getCommentIDToReply;
  }

  get openPanelReplyId(): string {
    return store.getters.getReplyPanelOpenID;
  }

  @Watch('openPanelReplyId')
  private onCommentIDToReplyChange() {

    if (!this.isFullscreen) {
      return;
    } else {
      this.askPanelInFullScreen = true;
    }
    this.fixUrl();
  }

  private fixUrl() {
    let title = this.title;
    if (this.weet) {
      title = this.weet.title;
    }
    history.replaceState({}, '', '/play/' + this.weetID + '/' + slugify(title));
  }

  get selectedWorkspace(): string {
    return store.getters.getSelectedWorkspaceID;
  }

  @Watch('weet')
  private selectWorkspaceOfWeet() {
    selectWorkspaceFromWeet(this.weet);
  }

  get nameOfOwner(): string {
    if (this.weet) {
      for (const owner of this.weet.owners) {
        if (owner.owner) {
          if (owner.user) {
            return capitalize(owner.user.firstName) + ' ' + capitalize(owner.user.lastName);
          }
        }
      }
    }
    return this.$t('generic.anonymous').toString();
  }

  get mustShowInteraction() {
    if (!this.isFullscreen) {
      return true;
    } else {
      return this.isFullscreen && this.askPanelInFullScreen;
    }

  }

  get dateOfCreation(): string {
    if (this.weet === undefined) {
      return '';
    }
    return ' ' + capitalize(getDateAgo(this.weet.created));
  }


  get toolTipDateCreation(): string {
    if (this.weet === undefined) {
      return '';
    }
    return getLocalTime(this.weet.created);
  }

  get weetTitle(): string {
    const weet = this.weet;
    if (weet === undefined) {
      return this.title;
    } else {
      if (this.title === '' || this.title !== weet.title) {
        this.fixUrl();
      }
      return weet.title;
    }
  }

  get weetTitleSEO(): string {
    return 'Weet | ' + this.weetTitle;
  }

  get weetIndexSEO(): string {
    if (this.weet) {
      if (this.weet.visibilityPolicy === VisibilityPolicy.PUBLIC) {
        return 'all';
      }
    }
    return 'noindex';
  }

  get thumbnailSEO(): string {

    // we search the event with 0
    if (this.weet !== undefined && this.weet.timeLine.length > 0) {
      const timeEvent = this.weet.timeLine[0];
      let mediaId = '';
      if (timeEvent.mainMedia.mediaID !== undefined && timeEvent.mainMedia.mediaID !== '') {
        mediaId = timeEvent.mainMedia.mediaID;
      } else {
        mediaId = timeEvent.secondMedia.mediaID;
      }
      // get the jogID for media
      for (const media of this.weet.medias) {
        if (media.mediaID === mediaId) {
          return getThumbnailURL(media.jobID);
        }
      }
    }
    return 'https://oneImage';
  }

  /**
   * Is editable by an owner or a coowner
   */
  get isEditable(): boolean {
    if (this.weet) {
      return canEditThisWeet(this.weet);
    } else {
      return false;
    }
  }


  get isAuthenticated(): boolean {
    return store.getters.isAuthenticated;
  }


  private editAWeet() {
    hideGlobalTour();
    setActionEvent(ActionEvent.player_button_edit);
    store.dispatch(SELECT_MODE, AdvancedEditingMode.NONE);
    launchWeetCreation(this.weet.weetID);
  }

  private validateTitle(event: Event) {
    if (event.target != null) {
      const element = event.target as HTMLElement;
      if (element.innerText.trim() !== this.weet.title.trim()) {
        setActionEvent(ActionEvent.player_change_title);
        store.dispatch(SEND_CHANGE_WEET_TITLE,
            {
              weetID: this.weet.weetID,
              title: element.innerText.trim(),
            }).then(() => {
          this.errormsg = '';
        }).catch((err) => {
          this.errormsg = err;
        });
        inform(this.$t('player.title.edition.success').toString());
      }
    }
  }

  private focusOutTitleEdition(event: KeyboardEvent) {
    if (event.target != null) {
      const element = event.target as HTMLElement;
      element.blur();
    }
  }

  private onControlChange(value: boolean) {
    this.controlPlayerShow = value;
  }


}
</script>
<style lang="scss">
/** TODO do better */
.rightColumnTabs {
  &.b-tabs {
    .tab-content {
      padding: 0px;
      padding-top: 8px;
    }

    .tabs {
      margin-left: 24px;
      margin-right: 20px;

      a {
        padding-top: 0px;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
@import '@/scss/shadows.scss';
@import '@/scss/animation.scss';
@import '@/scss/gridBreakPoint.scss';


$max-width: 1024px;
.playWeetLayout {
  padding: 32px;
  padding-bottom: 0px;
  max-width: 100%;

  @include GRID1X {
    padding-top: 32px;
    padding-bottom: 32px;
    padding-left: 8px;
    padding-right: 8px;
  }

  .mainLineLayout {
    width: 100%;
    display: flex;
    max-width: 1200px;
    margin: auto;
    flex-wrap: wrap;

    .topBar {
      width: 100%;
      padding-right: 16px;
      margin-bottom: 16px;
      @include GRID1X {
        padding-right: 0px;
      }

      .emptyTitleContainer {
        width: 100%;
        min-height: 34px;
      }

      .titleContainer {
        width: 100%;


        .lineContainer {
          display: flex;

          .topBarLeft {
            flex: 1;

            .titleEditable {
              font-size: 24px;
              font-weight: 900;
              width: 100%;
              border-radius: 4px;
              color: var(--black);
              text-align: left;
              line-height: 32px;
              margin-right: 20px;

              &.editable {
                &:hover {
                  box-shadow: 0px 0px 2px var(--light2);
                }

                &:focus {
                  box-shadow: 0px 0px 2px var(--primary);
                }
              }

              @include GRID1X {
                font-size: 14px;
                margin-right: 8px;
                line-height: 22px;

              }
            }
          }

          .topBarRight {
            padding-left: 24px;
            min-width: 400px;
            max-width: 400px;
            display: flex;
            justify-content: flex-end;

            .channelWeetContainer {
              flex: 1;
              text-align: left;
              margin-right: 8px;
              display: flex;
              align-items: flex-start;
              padding-top: 6px;
            }

            @include GRID1X {
              min-width: 0px;
              max-width: 400px;
            }
          }
        }
      }


    }

    .columnleft {
      flex: 1;
      padding-bottom: 32px;
      max-width: $max-width;
      min-width: 500px;

      &.central {
        margin: auto;
      }

      @include GRID1X {
        min-width: 300px;
      }
      @include GRID2X {
        min-width: 450px;
      }


      .weetContainer {
        margin-top: 0px;
        background: var(--dark);
        //  min-height: 522px;
        position: relative;
        max-height: $maxPlayerHeight;
        max-width: $max-width;
        min-height: $minPlayerHeight;
        // max-height: 580px;
        @extend .shadow1;
        border-radius: 8px;

      }

    }

    .columnRight {
      position: relative;
      animation-duration: 0.5s;
      min-width: 415px;
      max-width: 415px;
      @include GRID1X {
        min-width: 320px;
        width: 100%;
      }

      .spacerFullScreen {
        height: 32px;
      }

      .closeButton {
        position: absolute;
        top: 8px;
        right: 8px;
      }

      .roundChannel {
        background: var(--light);
        font-size: 14px;
        line-height: 18px;
        border-radius: 24px;
        padding-left: 4px;
        padding-right: 4px;
        color: var(--light2);
        display: inline-block;
      }

      .commentCreatorRightPanel {
        margin-top: 0px;
        margin-right: 16px;
        margin-bottom: 4px;
        @include GRID1X {
          margin-right: 8px;
          width: 100%;
        }

        .panelCreator {
          margin-left: 24px;
          max-width: 375px;
          @include GRID1X {
            width: 100%;
            margin-left: 0px;
            margin-top: 0px;
          }

        }

        .commentCreatorRightPanelTitle {
          font-size: 24px;
          text-transform: capitalize;
          font-weight: 900;
          margin-left: 32px;
          color: var(--black);
          text-align: left;
          margin-bottom: 20px;

          @include GRID1X {
            font-size: 16px;
            width: 100%;
            margin-left: 0px;
            margin-bottom: 0px;
          }
        }
      }
    }

    .weetInformation {
      padding-left: 0px;
      margin-top: 16px;
      text-align: left;

      .ownersLine {
        display: flex;
        width: 100%;
        height: 36px;
        max-height: 36px;
        margin-top: -2px;
        padding-right: 0px;

        .leftColumn {
          display: flex;;
          align-items: center;
          flex: 1;

          .ownerElement {
            margin-left: 0px;
            text-align: left;
            color: var(--light2);
            display: flex;
            font-size: 14px;
            font-weight: 600;
            line-height: 22px;
            align-self: center;

            .dotSeperator {
              margin-left: 4px;
              margin-right: 4px;
            }

            @include GRID1X {
              font-size: 12px;
              .dotSeperator {
                margin-left: 2px;
                margin-right: 2px;
              }
            }
          }
        }

        .rightColumn {
          display: flex;
          .archiveElement{
            color: var(--light2);
            font-size: 14px;
            display: flex;
            align-items: center;
            height: 32px;
            margin-right: 8px;
            .icon{
              margin-right: 8px;
            }
          }
          .buttonAction {
            margin-left: 4px;
          }
        }
      }
    }

    .statLine {
      display: flex;
      text-align: right;
      margin-top: 0px;
      padding-right: 0px;

      @include GRID1X {
        margin-top: 0px;
      }

      .statElement {

        display: flex;
        margin-top: 0px;
        font-size: 14px;
        font-weight: 600;
        color: var(--dark);
        align-items: center;

        .numberView {
          margin-right: 16px;
          margin-left: 8px;
        }


        .iconView {
          margin-right: 4px;
          max-width: 16px;
        }

      }

    }

    .notificationHelper {
      margin-left: 24px;
      // z-index: 1;
    }

    .commentPanelView {
      margin-left: 16px;
      min-width: 320px;
      min-height: 220px;
      max-height: calc(100% - 135px);

      @include GRID1X {
        min-width: 300px;
        margin-left: 0px;
      }
    }
  }

  .errorMessage {
    margin-top: 24px;
  }


  &.layoutFullScreen {
    padding: 0;

    .openFullscreenPanelButton {
      position: absolute;
      top: 32px;
      right: 32px;
      color: white;
      cursor: pointer;
      transition: transform 0.2s ease;

      &:hover {
        transform: scale(1.2);
      }
    }

    .topBar {
      margin-bottom: 0px;
    }

    .mainLineLayout {
      max-width: 100%;
      height: 100%;

      .columnleft {
        max-width: 100%;
        max-height: 100%;
        width: 100%;
        height: 100%;
        padding: 0px;


        .weetContainer {
          max-height: 100%;
          height: 100%;
          max-width: 100%;
          width: 100%;
        }
      }

      .columnRight {
        position: absolute;
        top: 0px;
        right: 0px;
        background: rgba(255, 255, 255, 1);
        margin-right: 0px;
        height: 100%;
        @extend .shadow3;

        .commentCreatorRightPanelTitle {
          margin-top: 24px;
        }
      }

      .titleContainer {
        display: none;
      }
    }
  }

  &.layoutMobile {
    .mainLineLayout {
      .columnleft {
        .weetContainer {
          min-height: 100px;
        }
      }
    }
  }
}

</style>
